/**
 * @voltxampere/spice — Element codec interface
 *
 * Each SPICE element family (R, C, L, V, …) gets one `ElementCodec`
 * implementation that knows:
 *
 *   - which schema component type strings it owns
 *   - how to slice an `ElementCard.tokens` array into nodes / value /
 *     extras for parsing
 *   - how to render a `ComponentInstance` back to a SPICE line
 *
 * Round-trip parity (ADR-0029) is the codec's responsibility:
 * `parse(emit(component))` must yield a structurally-equal
 * component (modulo position auto-layout, see ADR-0030).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export function ok(component, nodeNames) {
    return { ok: true, component, nodeNames };
}
export function err(message) {
    return { ok: false, error: message };
}
//# sourceMappingURL=_base.js.map